import { useContext } from 'react';
import { AnimationContext } from './AnimationContext.js';

function useAnimationContext() {
  const animationContext = useContext(AnimationContext);
  // eslint-disable-next-line no-constant-binary-expression, valid-typeof -- Legacy lint baseline; see docs/development/lint-baseline-followups.md. Refs: ARCH-56
  if (typeof animationContext === undefined) {
    throw new Error('useAnimationContext must be used within an AnimationContext');
  }
  return animationContext;
}

export { useAnimationContext };
